<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
/* 
 * =================== Coupon Logic ===================
 * This section handles the coupon application logic.
 */
document.addEventListener('DOMContentLoaded', function() {
  const couponItems = [
    { discount: '18% OFF $7,999+', code: 'GET18' },
    { discount: '15% OFF $3,999+', code: 'GET15' },
    { discount: '10% OFF For All Order', code: 'GET10' }
  ];

  const container = document.querySelector('.ella-coupon-container');
  if (!container) {
    console.error('Coupon container not found. Selector: .ella-coupon-container');
    return;
  }

  const header = container.querySelector('.ella-coupon-header');
  const content = container.querySelector('.ella-coupon-content');
  const arrow = container.querySelector('.ella-coupon-arrow');

  if (!header || !content || !arrow) {
    console.error('One or more coupon elements not found. Check your HTML structure.');
    return;
  }

  function toggleCoupon() {
    console.log('Toggle function called');
    const isOpen = container.classList.toggle('open');
    arrow.textContent = isOpen ? '▲' : '▼';
    
    if (isOpen) {
      content.style.display = 'block';
      content.style.maxHeight = content.scrollHeight + 'px';
      content.hidden = false;
    } else {
      content.style.maxHeight = '0px';
      setTimeout(() => {
        content.style.display = 'none';
        content.hidden = true;
      }, 300); // Match this with your CSS transition time
    }
    
    header.setAttribute('aria-expanded', isOpen);
    console.log(`Coupon content ${isOpen ? 'opened' : 'closed'}`);
    console.log('Container classes:', container.className);
    console.log('Content max-height:', content.style.maxHeight);
    console.log('Content display:', content.style.display);
    console.log('Content hidden:', content.hidden);
  }

  function createCouponItems() {
    console.log('Creating coupon items');
    const fragment = document.createDocumentFragment();
    couponItems.forEach(item => {
      const itemElement = document.createElement('div');
      itemElement.className = 'ella-coupon-item';
      itemElement.innerHTML = `
        <span class="ella-coupon-discount">${item.discount}</span>
        <div>
          <span class="ella-coupon-code">Code: ${item.code}</span>
          <button class="ella-coupon-copy-btn" data-coupon-code="${item.code}">Copy</button>
        </div>
      `;
      fragment.appendChild(itemElement);
    });
    content.appendChild(fragment);
    console.log('Coupon items created:', couponItems.length);
  }

  function handleCopyClick(event) {
    if (event.target.classList.contains('ella-coupon-copy-btn')) {
      const code = event.target.getAttribute('data-coupon-code');
      navigator.clipboard.writeText(code)
        .then(() => {
          event.target.textContent = 'Copied!';
          event.target.classList.add('copied');
          event.target.disabled = true;
          setTimeout(() => {
            event.target.textContent = 'Copy';
            event.target.classList.remove('copied');
            event.target.disabled = false;
          }, 2000);
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
          alert('Failed to copy code. Please try again.');
        });
    }
  }

  // Initialize
  header.addEventListener('click', toggleCoupon);
  content.addEventListener('click', handleCopyClick);
  createCouponItems();

  // Set initial state
  content.style.maxHeight = '0px';
  content.style.display = 'none';
  content.hidden = true;
  arrow.textContent = '▼';
  header.setAttribute('aria-expanded', 'false');

  // Make header focusable and add keyboard support
  header.setAttribute('tabindex', '0');
  header.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleCoupon();
    }
  });

  console.log('Debug coupon script initialized');
  console.log('Initial content state:', {
    maxHeight: content.style.maxHeight,
    display: content.style.display,
    hidden: content.hidden
  });
});
/* 
 * =================== End Chat Functionality ===================
 */

/* 
 * =================== Chat Functionality ===================
 * This section handles the custom chat link behavior.
 * It intercepts the click event on the chat link and
 * triggers the Shopify chat widget programmatically.
 */

window.ac = window.ac || {};
document.addEventListener('DOMContentLoaded', function() {
  ac.chatLink = document.querySelector("a[href='#chat']");

  if (ac.chatLink) {
    ac.chatLink.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      var shopifyChat = document.getElementById("ShopifyChat");
      if (shopifyChat && shopifyChat.shadowRoot) {
        var chatToggle = shopifyChat.shadowRoot.querySelector("button.chat-toggle");
        if (chatToggle) {
          chatToggle.click();
        }
      }
    });
  }
});

/* 
 * =================== End Chat Functionality ===================
 */